<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="card_container"
          style="flex: 0 0 20%; border-radius: 10px; flex: 0 0 24%"
        >
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="mt-3 col-md-6 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                @click="activateTab('table')"
                :class="[activeTab === 'table' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/list.png" width="60%" />
              </div>
              <div class="text-center tab" style="font-size: 12px">
                {{ $t("text.fuelConsumption.table") }}
              </div>
            </div>
            <div class="mt-3 col-md-6 fuel_consumption_btn_div">
              <div
                class="fuel_consumption_button"
                @click="activateTab('chart')"
                :class="[activeTab === 'chart' ? 'active_tab' : null]"
              >
                <img src="@/assets/img/analytics.png" width="35px" />
              </div>
              <div class="text-center tab" style="font-size: 12px">
                {{ $t("text.fuelConsumption.chart") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="mr-3 fuel_consumption_row_right_section vr__bg"
          style="border-radius: 12px; flex: 0 0 72%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-5"
              style="display: flex; justify-content: center"
            >
              <h6 class="ml-2 text-center text-white">
                {{ $t("text.fuelConsumption.title") }} ({{
                  $t("text.fuelConsumption.plateNumber")
                }}
                {{ this.$route.query.plateNumber }})
              </h6>
            </div>
            <div
              class="col-md-7"
              style="display: flex; justify-content: center"
            >
              <div class="mt-2 mr-2 drop_down_section">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    color="#4b2d73"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                    :excelQueryCellInfo="excelQueryCellInfo"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 text-center transaction_period_text"></div>
        </div>
      </div>
      <section class="mt-3 section__row" v-show="activeTab === 'table'">
        <div class="">
          <div class="">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :actionBegin="actionHandler"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="40" headerText="#"></e-column>

                <e-column
                  field="date"
                  :format="formatOptions"
                  type="date"
                  width="200"
                  :headerText="$t('text.fuelConsumption.date')"
                ></e-column>
                <e-column
                  field="driver"
                  width="150"
                  :headerText="$t('text.fuelConsumption.driver')"
                ></e-column>
                <e-column
                  field="plateNumber"
                  width="150"
                  :headerText="$t('text.fuelConsumption.plateNumber')"
                ></e-column>
                <e-column
                  field="voucherUser"
                  width="300"
                  :headerText="$t('text.fuelConsumption.createdBy')"
                ></e-column>
                <e-column
                  field="volSold"
                  format="N2"
                  width="200"
                  :headerText="$t('text.fuelConsumption.volume')"
                ></e-column>
                <e-column
                  field="priceSold"
                  format="N2"
                  width="150"
                  textAlign="Right"
                  :headerText="$t('text.fuelConsumption.pricePerLitre')"
                ></e-column>
                <e-column
                  field="voucherCardNumber"
                  :headerText="$t('text.fuelConsumption.voucher')"
                  width="150"
                ></e-column>
                <!-- <e-column
                  field="plateNumber"
                  headerText="Plate Number"
                  width="150"
                ></e-column> -->
                <e-column
                  field="branchName"
                  :headerText="$t('text.fuelConsumption.stationName')"
                  width="350"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <div class="mt-3" style="margin: 0 auto">
              <Paginator
                v-show="!showLoader"
                :total-pages="totalPages"
                :per-page="pageSize"
                :current-page="currentPage"
                @pagechanged="onPageChange"
                @getPageSize="getPageSize"
                :pageSize="pageSize"
              />
            </div>

            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <section class="py-3 mt-3 section_2" v-show="activeTab === 'chart'">
        <highcharts
          :options="chartOptions"
          class="mr-3 high_charts high__charts__fuel__consumption"
          v-if="!showLoader"
        ></highcharts>
        <div class="showLoaderDiv charts__loader" style="" v-if="showLoader">
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import Paginator from "@/components/Paginator.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  Resize,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Vehicle Fuel Consumption:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    highcharts: Chart,
    TableLoader,
    Paginator,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      sortingTable: false,
      sortType: "",
      sortColumn: "",
      searchValue: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      searchTotalPages: 1,
      showLoader: true,
      tableCount: 0,

      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      activeTab: "table",
      chartTableData: null,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      chartOptions: {
        chart: {
          type: "areaspline",
        },
        title: {
          text: this.$t("text.fuelConsumption.fuelConsumptionStats"),
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: null,
        xAxis: {
          categories: null,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.fuelConsumption.totalVolume"),
          },
        },
        legend: {
          enabled: true,
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
        },
      },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div v-show="data"> 
                  <button type="button" class="btn btn-info" title="View Fuel Consumption" v-show="!data.closed "  @click="assignShift(data)"   >
                     <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                </div>
                `,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              assignShift: function (shift) {
                this.$eventHub.$emit("_getShift", shift);
              },
              _closeShift: function (shift) {
                this.$eventHub.$emit("closeShift", shift);
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTransactionChartsData();
        this.getTransactionTableData();
      }
    },
  },
  mounted() {
    this.getTransactionTableData();
    this.getTransactionChartsData();
    this.getTransactionChartsData();
    this.getTransactionTableData();
    $(".e-input").keyup(function (e) {
      if (e.keyCode === 13) {
        searchFun(e, 13);
      } else {
        searchFun(e, 1);
      }
    });
    const searchFun = (event, number) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      this.searchValue = value;
      if (number !== 13 && value.length > 3) {
        this.getTransactionChartsData();
        this.getTransactionTableData();
      }
      if (number == 13) {
        this.getTransactionChartsData();
        this.getTransactionTableData();
      }
      if (!value.length) {
        this.getTransactionChartsData();
        this.getTransactionTableData();
      }
    };
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: `${this.$route.query.plateNumber} Fuel Consumption.pdf`,
          };
          this.$refs.dataGrid.getColumns()[0].width = "60";
          this.$refs.dataGrid.getColumns()[1].width = "140";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "120";
          this.$refs.dataGrid.getColumns()[4].width = "120";
          this.$refs.dataGrid.getColumns()[5].width = "80";
          this.$refs.dataGrid.getColumns()[6].width = "80";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.getColumns()[8].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: `${this.$route.query.plateNumber} Fuel Consumption.xlsx`,
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }

      setTimeout(() => {
        this.$refs.dataGrid.getColumns()[0].width = "40";
        this.$refs.dataGrid.getColumns()[1].width = "200";
        this.$refs.dataGrid.getColumns()[2].width = "150";
        this.$refs.dataGrid.getColumns()[3].width = "150";
        this.$refs.dataGrid.getColumns()[4].width = "300";
        this.$refs.dataGrid.getColumns()[5].width = "200";
        this.$refs.dataGrid.getColumns()[6].width = "150";
        this.$refs.dataGrid.getColumns()[7].width = "150";
        this.$refs.dataGrid.getColumns()[8].width = "350";
      }, 1000);
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },

    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },

    getTransactionChartsData() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Track/FuelConsumptionChart?startDate=${this.startDate}&endDate=${this.endDate}&plateNumber=${this.$route.query.plateNumber}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.chartOptions.series = response.data.series;
          this.chartOptions.xAxis.categories = response.data.categories;
        })
        .catch((error) => {
          this.showLoader = false;
          // this.$toast.open({
          //   message: error.response.data.message,
          //   type: "error",
          //   duration: 5000
          // });
        });
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.fuelConsumptionCount / pageSize);
      this.getTransactionTableData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getTransactionTableData();
    },
    actionHandler: function (args) {
      if (args.requestType == "sorting") {
        if (args.direction) {
          this.sortType = args.direction;
          this.sortColumn = args.columnName;
        } else {
          this.sortType = "";
          this.sortColumn = "";
        }

        //  this.getTransactionChartsData();
        this.getTransactionTableData();
      }
    },
    getTransactionTableData() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Track/FuelConsumptionTable?startDate=${this.startDate}&endDate=${this.endDate}&plateNumber=${this.$route.query.plateNumber}&pageSize=${this.pageSize}&pageIndex=${this.currentPage}&filterQuery=${this.searchValue}&sortOrder=${this.sortType}&sortColumn=${this.sortColumn}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.fuelConsumptionCount = response.data.totalCount;
          this.totalPages = Math.ceil(response.data.totalCount / this.pageSize);
          this.tableCount = response.data.totalCount;
          let index = (this.currentPage - 1) * this.pageSize;

          response.data.data.forEach((consumption) => {
            consumption.plateNumber = consumption.plateNumber
              ? consumption.plateNumber
              : "N/A";
            consumption.parent = consumption.parent
              ? consumption.parent
              : "N/A";
            if (!consumption.userState) {
              consumption.userState = "N/A";
            }
            consumption.index = ++index;
          });

          this.showLoader = false;
          grid.ej2Instances.setProperties({
            dataSource: response.data.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "An Error Occured",
              type: "error",
              duration: 5000,
            });
          }
        });
    },

    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet");
    },
  },
};
</script>
